import { PayloadAction } from '@reduxjs/toolkit';
import { call, put, takeEvery } from 'redux-saga/effects';
import { actions } from '../Slice/FilterSlice';
import { GetFollowPeopleDistincts, GetSearchContentDistincts, GetSimilarPeopleDistincts } from '../Types/RequestBodies';
import axios from 'Utils/Axios';
import { SearchContentDistinctsResponse } from '../Types/ResponseBodies';
import { API } from '../Utils/Constants';
import { GetAdvancedSearchDistincts } from '../Types/AdvanceSearchResultsTypes';

export function* getSearchContentDistincts(dispatched: PayloadAction<GetSearchContentDistincts>) {
  try {
    const response: SearchContentDistinctsResponse = yield call(
      axios.post,
      API.SEARCH_CONTENT_DISTINCTS,
      dispatched.payload,
    )
    if (response.status === true) {
      yield put(actions.setSearchContentDistincts({
        type: dispatched.payload.type,
        response: response.response,
      }))
    }
  } catch (err) {
    console.log(err);
  }
}

export function* getAdvancedSearchDistincts(dispatched: PayloadAction<GetAdvancedSearchDistincts>) {
  try {
    const response: SearchContentDistinctsResponse = yield call(
      axios.post,
      API.ADVANCED_SEARCH_DISTINCTS,
      dispatched?.payload,
    )
    if (response.status === true) {
      yield put(actions.setAdvancedSearchDistincts({
        type: dispatched?.payload?.type,
        response: response.response,
      }));
    }
  } catch (err) {
    console.log(err);
  }
}

export function* getSimilarPeopleDistincts(dispatched: PayloadAction<GetSimilarPeopleDistincts>) {
  try {
    const response: SearchContentDistinctsResponse = yield call(
      axios.post,
      API.GET_SIMILAR_PEOPLE_DISTINCTS,
      dispatched?.payload
    )
    if (response?.status === true) {
      yield put(actions.setSimilarDistincts({
        type: dispatched?.payload?.type,
        response: response?.response,
      }))
    }

  } catch (err) {
    console.log(err);
  }
}

export function* getFollowedPeopleDistincts(dispatched: PayloadAction<GetFollowPeopleDistincts>) {
  try {
    const response: SearchContentDistinctsResponse = yield call(
      axios.post,
      API.GET_FOLLOWED_PEOPLE_DISTINCTS,
      dispatched?.payload,
    )
    if (response?.status === true) {
      console.log("follow from saga:", response);
      yield put(actions.setFollowedPeopleDistincts({
        type: dispatched?.payload?.type,
        response: response?.response,
      }))
    }
  } catch (err) {
    console.log(err);
  }
}

export function* filterSaga() {
  yield takeEvery(actions.getSearchContentDistincts.type, getSearchContentDistincts);
  yield takeEvery(actions.getAdvancedSearchDistincts.type, getAdvancedSearchDistincts);
  yield takeEvery(actions.getSimilarPeopleDistincts.type, getSimilarPeopleDistincts);
  yield takeEvery(actions.getFollowedPeopleDistincts.type, getFollowedPeopleDistincts);
}